import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'
import {
  CreateNewInstallableMutation,
  CreateNewInstallableMutationVariables
} from './__generated__/CreateNewInstallableMutation'
import {
  CreateNewInstallableDefinitionMutation,
  CreateNewInstallableDefinitionMutationVariables
} from './__generated__/CreateNewInstallableDefinitionMutation'

const MUTATION = gql`
  mutation CreateNewInstallableMutation($input: PublishInstallableInput!) {
    publishInstallable(input: $input) {
      id
    }
  }
`

const DEFINITION_MUTATION = gql`
  mutation CreateNewInstallableDefinitionMutation($input: CreateInstallableDefinitionInputV2!) {
    createInstallableDefinitionV2(input: $input) {
      ... on InstallableDefinitionV2 {
        installableId
        definitionJson
      }
      ... on InstallableErrorV2 {
        type
        error
      }
    }
  }
`
export const useCreateInstallable = () => {
  return useMutation<CreateNewInstallableMutation, CreateNewInstallableMutationVariables>(MUTATION)
}

export const useCreateInstallableDefinition = () => {
  return useMutation<CreateNewInstallableDefinitionMutation, CreateNewInstallableDefinitionMutationVariables>(
    DEFINITION_MUTATION
  )
}
